const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  businessType: state => state.app.businessType,
  businessTags: state => state.app.businessTags,
  token: state => state.user.token,
  mode: state => state.user.mode,
  isVersion: state => state.user.isVersion,
  ogToken: state => state.user.ogToken,
  avatar: state => state.user.avatar,
  Logo: state => state.user.Logo,
  isAddTask: state => state.user.isAddTask,
  isAddPlan: state => state.user.isAddPlan,
  viewNumber: state => state.user.viewNumber,
  name: state => state.user.name,
  roles: state => state.user.roles,
  is_access_iams: state => state.user.is_access_iams,
  DNC: state => state.user.DNC,
  product_and_permission: state => state.user.product_and_permission,
  id: state => state.user.id,
  status: state => state.user.status,
  language: state => state.user.language,
  permission_routes: state => state.permission.routes,
  permissions: state => state.user.permissions,
  addRoutes: state => state.permission.addRoutes,
  usertime: state => state.user.usertime,
  sidebarRouters: state => state.permission.sidebarRouters,
  topbarRouters: state => state.permission.topbarRouters,
  defaultRoutes: state => state.permission.defaultRoutes,
  intentionTags: state => state.user.intentionTags,
  show_dashboard: state => state.user.show_dashboard,
  userInfo: state => state.user.userInfo,
  licenseInfo: state => state.user.userInfo.license_info,
  loginInfo: state => state.user.loginInfo,
  isShowLicenseTip: state => state.user.isShowLicenseTip,
  showDownloadCenter: state => state.app.showDownloadCenter,
  downloadCenterCount: state => state.app.downloadCenterCount,
  detail_language: state => state.user.detail_language,
  robot: state => state.robot.robot, // 查看机器人详情、新增挂机短信
  detailBreadcrumbList: state => state.robot.detailBreadcrumbList, // 查看详情面包屑
  addHangUpMessageBreadcrumbList: state => state.robot.addHangUpMessageBreadcrumbList, // 新增挂机短信面包屑
  robotIntentions: state => state.robot.robotIntentions, // 新增挂机短信 意向标签 下拉框数据
  robotPlatforms: state => state.robot.robotPlatforms, // 新增挂机短信 platform 下拉框数据
  hangUpMessageData: state => state.robot.hangUpMessageData, // 编辑挂机短信数据
  logoName: state => state.app.logoName,
  stencilGroup: state => state.app.stencilGroup
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js